import React, { useState, useRef } from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import classes from '../style/redirect.module.scss';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'query-string';



const Redirect = (props: any) => {
    const location = useLocation();
    const history = useHistory();
    const parameters = useRef(qs.parse(location.search));
    console.log(parameters);

    return (
        <>
            {
                parameters.current.refNumber ? (
                    <div style={{ textAlign: 'center', margin: '40px 0' }} className={classes.root}  >
                        <Grid justifyContent="center">
                            <img className="banner-img" src='/Successful.svg' alt="success" />
                        </Grid>
                        <Grid container justifyContent="center" spacing={3} >
                            <Grid item xs={12} >
                                <Typography variant="h3" component="h2" >
                                    {'پرداخت با موفقیت انجام شد'}
                                </Typography>
                            </Grid>
                            {/* <Grid item xs={12} >
                                <div className={classes.item}>
                                    <span className={classes.label}>{'شناسه فاکتور:  '}</span>
                                    <span data-cy="trackingCode">
                                        &nbsp;&nbsp;{parameters.current.invoiceId}
                                    </span>
                                </div>
                            </Grid> */}
                            <Grid item xs={12} >
                                <div className={classes.item}>
                                    <span className={classes.label}>{'شناسه پرداخت:  '}</span>
                                    <span data-cy="trackingCode">
                                        &nbsp;&nbsp;{parameters.current.refNumber}
                                    </span>
                                </div>
                            </Grid>
                            <Grid item xs={12} >
                                <Button style={{ width: '20%', height: '50px' }} variant="contained" color="primary" onClick={() => { history.push('/financial-management') }} >
                                    {'بازگشت به روناد'}
                                </Button>
                            </Grid>

                        </Grid>
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', margin: '40px 0' }} className={classes.root}  >
                        <Grid justifyContent="center">
                            <img className="banner-img" src='/Unsuccessful.svg' alt="success" />
                        </Grid>
                        <Grid container justifyContent="center" spacing={3} >
                            <Grid item xs={12} >
                                <Typography variant="h3" component="h2" >
                                    {'متاسفانه پرداخت انجام نشد !'}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} >
                                <div className={classes.item}>
                                    <span className={classes.label}>
                                        {'درصورتیکه مبلغی از حساب شما کسر شده است، طی 72 ساعت آینده به حساب شما باز خواهد گشت.'}
                                    </span>
                                </div>
                            </Grid>
                            <Grid item xs={12} >
                                <Button style={{ width: '20%', height: '50px' }} variant="contained" color="primary" onClick={() => { history.push('/financial-management') }} >
                                    {'بازگشت به روناد'}
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                )
            }

        </>
    )

}

export default Redirect;